export default __webpack_public_path__ + "static/RootSans-7SemiBold-5e30732e3d1eb736da94e1c662be4337.woff2";